import { jsx, jsxs } from 'react/jsx-runtime';
import { Skeleton } from '../../../../components/Skeleton/Skeleton.js';
import { useInternalDynamicContext } from '../../../../context/DynamicContext/useInternalDynamicContext.js';
import { useViewContext } from '../../../../context/ViewContext/ViewContext.js';
import '@dynamic-labs/sdk-api';
import '../../../../shared/logger.js';
import { getFromLS } from '../../../../shared/utils/functions/storage/getFromLS.js';
import '../../../../config/LSSuffix.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react';
import '@dynamic-labs/utils';
import { AUTH_USER } from '../../../../utils/constants/localStorage.js';
import '../../../../utils/constants/colors.js';
import 'ethers';
import '../../../../shared/consts/index.js';
import { WalletListItem } from '../../../WalletList/WalletListItem/WalletListItem.js';
import { ListItemButton } from '../ListItemButton/ListItemButton.js';

const NUMBER_OF_WALLETS = 3;
const LoginWithEmailWalletList = ({ walletsList, numberOfWallets, }) => {
    const { setView } = useViewContext();
    const { projectSettings, connectedWallets } = useInternalDynamicContext();
    const isUsingMultiWallet = Boolean(getFromLS(AUTH_USER));
    return !projectSettings ? (jsx(Skeleton, { count: NUMBER_OF_WALLETS + 1, className: 'login-with-email-wallet-list__skeleton' })) : (jsxs("div", Object.assign({ className: 'login-with-email-wallet-list__container' }, { children: [walletsList.map((wallet) => (jsx(WalletListItem, { wallet: wallet, connectedWallets: connectedWallets, usingMultiWallet: isUsingMultiWallet }, wallet.key))), jsx(ListItemButton, { text: 'View all wallets', onClick: () => setView('login-with-email-or-wallet-full-wallet-list'), numberOfWallets: numberOfWallets })] })));
};

export { LoginWithEmailWalletList, NUMBER_OF_WALLETS };
